import { g } from '@clientio/rappid';

import { LINK_BEND_SIZE } from '../../../base/flowchart.config';

interface XYPosition {
  x: number;
  y: number;
}

const distance = (a: XYPosition, b: XYPosition) => Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));

function getBend(a: XYPosition, b: XYPosition, c: XYPosition, size: number): g.PathSegmentUnit[] {
  const bendSize = Math.min(distance(a, b) / 2, distance(b, c) / 2, size);
  const { x, y } = b;
  const segments: g.PathSegmentUnit[] = [];

  // no bend
  if ((a.x === x && x === c.x) || (a.y === y && y === c.y)) {
    segments.push(g.Path.createSegment('L', { x, y }));
    return segments;
  }

  let xDir = 0;
  let yDir = 0;

  // first segment is horizontal
  if (a.y === y) {
    xDir = a.x < c.x ? -1 : 1;
    yDir = a.y < c.y ? 1 : -1;
    segments.push(g.Path.createSegment('L', { x: x + bendSize * xDir, y }));
    segments.push(g.Path.createSegment('C', { x: x, y: y }, { x: x, y: y + bendSize * yDir }, { x: x, y: y + bendSize * yDir }));
    return segments;
  }

  xDir = a.x < c.x ? 1 : -1;
  yDir = a.y < c.y ? -1 : 1;
  segments.push(g.Path.createSegment('L', { x: x, y: y + bendSize * yDir }));
  segments.push(g.Path.createSegment('C', { x: x, y: y }, { x: x + bendSize * xDir, y: y }, { x: x + bendSize * xDir, y: y }));
  return segments;
}

export function connector(sourcePoint: XYPosition, targetPoint: XYPosition, vertices: XYPosition[]): g.Path {
  const points = [sourcePoint, ...vertices, targetPoint];

  const segments = points.flatMap((p, i) => {
    if (i > 0 && i < points.length - 1) {
      return getBend(points[i - 1], p, points[i + 1], LINK_BEND_SIZE);
    } else {
      return [g.Path.createSegment(i === 0 ? 'M' : 'L', { x: p.x, y: p.y })];
    }
  });

  return new g.Path(segments);
}
